<template>
  <v-app>
    <app-sidenav/>

    <v-main>
      <router-view @raison-event="openSnackBar"/>
    </v-main>

    <app-snackbar
      ref="appSnackbar"
      :type="snackbarType"
      :messages="snackbarMessages"
    />

    <help-panel/>
  </v-app>
</template>

<script>
import AppSidenav from '@/components/layout/AppSidenav';
import AppSnackbar from '@/components/global/AppSnackbar';
import HelpPanel from '@/components/layout/HelpPanel';
import {DEBUG_MODE} from '@/store/mutation-types';
import userRightMixin from '@/mixins/user-rights-mixin.js';

export default {
  name: 'App',

  components: {
    AppSidenav,
    AppSnackbar,
    HelpPanel,
  },

  mixins: [ userRightMixin ],

  data() {
    return {
      snackbarMessages: [],
      snackbarType: 'error',
    };
  },

  computed: {
    showToolbars () {
      const exlusions = ['/login', '/register']
      return !(exlusions.includes(this.$route.path))
    },
  },

  methods: {
    openSnackBar(raisonEvent) {
      let type = raisonEvent.type;
      let messages = raisonEvent.messages;
      this.snackbarType = type || 'error';
      messages = messages?.map(message => {
        let errorMessage = '';
        if (message && message.response && message.response.data && message.response.data.message) {
          errorMessage = message.response.data.message;
        }
        return errorMessage || message;
      });
      this.snackbarMessages = messages || [ 'Something went wrong...' ];
      this.$refs.appSnackbar.open = true;
    },
    onKeyPress(event) {
      // console.log('onKeyPress', event)
      if(event.key === '²' || (event.ctrlKey && event.key === '?')) {
        this.switchDebugMode()
      }
    },
    switchDebugMode() {
      this.$store.commit(DEBUG_MODE)
    },
  },

  beforeCreate() {
    this.$i18n.locale = localStorage.getItem("raisonSelectedLanguage") ||  process.env.VUE_APP_I18N_LOCALE;
  },

  created() {
    window.addEventListener('keypress', this.onKeyPress)
  },

  beforeDestroy() {
    window.removeEventListener('keypress', this.onKeyPress)
  }

};
</script>

<style>
@font-face {
  font-family: 'OpenSans';
  font-style: normal;
  font-weight: 400;
  src: local('OpenSans'), url('./fonts/OpenSans-Regular.ttf') format('truetype');
}
.v-application {
  font-family: "OpenSans", Roboto, sans-serif;
}
.v-application .primary--text {
    color: #06897e !important;
    caret-color: #06897e !important;
}
.v-content__wrap {
  background-color: #f3f1f2;
  font-family: "OpenSans", Roboto, sans-serif;
}
.chip-wrap {
  border: 3px dashed #062b89;
  border-radius: 5px;
  padding-top: 4px;
  padding-bottom: 4px;
  margin-right: 4px;
  float: left;
  display: flex;
}
.raison-btn {
  background-color: #FFD740 !important;
  /* background-color: #0D47A1 !important;
  color: white !important; */
  margin: 2px 4px 2px 4px;
}
.raison-highlight {
  background-color: #E0F2F1;
}
.clickable {
  cursor: pointer;
}
.rai-wigo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.rai-natural-language {
  word-break: break-word;
}
.rai-logical-language {
  word-break: break-word;
}
section pre {
  background-color: #ECEFF1;
  border: 1px solid #d3d3d3;
  border-radius: 5px;
  padding: 0px 8px 0px 8px;
  margin: 0px 2px;
  display: inline-block;
  font-family: monospace;
  font-size: 0.8em;
  white-space: pre-wrap;
}
section pre.button {
  background-color: #FFD740;
  border: 1px solid #FFD740;
  border-radius: 5px;
  padding: 0px 8px 0px 8px;
  margin: 0px 2px;
  display: inline-block;
  font-family: monospace;
  font-size: 0.8em;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
section pre.option {
  background-color: #062b89;
  border: 1px solid #062b89;
  color: white;
  border-radius: 5px;
  padding: 0px 8px 0px 8px;
  margin: 0px 2px;
  display: inline-block;
  font-family: monospace;
  font-size: 0.8em;
}
section pre.element {
  background-color: #a6eeea;
  border: 1px solid #a6eeea;
  border-radius: 15px;
  padding: 0px 8px 0px 8px;
  margin: 0px 2px;
  display: inline-block;
  font-family: monospace;
  font-size: 0.8em;
}
section pre.empty {
  background-color: white;
  border: 1px solid #E0E0E0;
  color: #616161;
  border-radius: 15px;
  padding: 0px 8px 0px 8px;
  margin: 0px 2px;
  display: inline-block;
  font-family: monospace;
  font-size: 0.8em;
}
.box {
  flex-wrap: wrap;
  justify-content: left;
}
</style>
